// Back-office navigation, as validated with Katia on 2026-09-24: what WooCommerce sends
// (colours, finishes, SKU list) is not administered twice, and there is one admin account.
// `upcoming` sections open a page that states what the screen will hold (ticket #8).

// The icons the navigation uses: `cup` is drawn by IconCup (heroicons has none), the others
// are checked by BaseIcon against the heroicons set.
type TAdminSectionIcon = 'cup' | 'FolderOpenIcon' | 'PhotoIcon' | 'RectangleGroupIcon' | 'SparklesIcon';

interface IAdminSection {
    // CDC requirements the screen answers, shown on the upcoming page.
    cdc: string[];
    contents: string[];
    icon: TAdminSectionIcon;
    isUpcoming: boolean;
    label: string;
    // Direct links to the section's tabs, listed under it in the menu (`onglet` query).
    links: { label: string; tab: string }[];
    path: string;
    summary: string;
}

// One flat list, in menu order (no sub-headings, Réglages IA above Projets: Katia 2026-09-25).
const ADMIN_SECTIONS: IAdminSection[] = [
    {
        label: 'Références',
        path: '/admin/references',
        icon: 'cup',
        isUpcoming: false,
        links: [],
        cdc: ['ADM-01', 'ADM-02'],
        summary: 'Les gobelets du catalogue et les styles d’impression proposés sur chacun.',
        contents: [],
    },
    {
        label: 'Modèles',
        path: '/admin/modeles',
        icon: 'RectangleGroupIcon',
        isUpcoming: false,
        links: [],
        cdc: ['ADM-03', 'RES-01'],
        summary: 'Les modèles à personnaliser proposés aux clients, par thématique.',
        contents: [
            'Galerie filtrable par thème, sous-thème, style d’impression et état',
            'Créer, dupliquer, activer, désactiver, supprimer',
            'Références compatibles et styles pour lesquels le modèle est proposé',
            'Ouvrir dans le configurateur pour éditer et verrouiller des éléments',
            'Mots-clés pour la recherche « Rechercher un modèle… »',
        ],
    },
    {
        label: 'Bibliothèque',
        path: '/admin/bibliotheque',
        icon: 'PhotoIcon',
        isUpcoming: false,
        links: [
            { label: 'Graduations', tab: 'graduations' },
            { label: 'Ressources graphiques', tab: 'ressources' },
            { label: 'Motifs de fond', tab: 'motifs' },
        ],
        cdc: ['RES-02', 'RES-03', 'EDI-09', 'ADM-05'],
        summary: 'Graduations, ressources graphiques et motifs de fond.',
        contents: [
            'Graduations : styles, thématiques, un SVG par référence × zone × placement',
            'Tableau de couverture : quelles références ont leurs fichiers de graduation',
            'Ressources graphiques SVG : catégorie, vignette, recoloration, styles compatibles',
            'Motifs de fond : taille de répétition, compatibilités',
        ],
    },
    {
        label: 'Réglages IA',
        path: '/admin/reglages-ia',
        icon: 'SparklesIcon',
        isUpcoming: false,
        links: [],
        cdc: ['IAS-01'],
        summary: 'La génération d’images par IA proposée dans l’éditeur.',
        contents: [],
    },
    {
        label: 'Projets',
        path: '/admin/projets',
        icon: 'FolderOpenIcon',
        isUpcoming: false,
        links: [],
        cdc: ['ADM-04'],
        summary: 'Les personnalisations enregistrées par les clients.',
        contents: [],
    },
];

export { ADMIN_SECTIONS };
